module.exports = __webpack_public_path__ + "/img/OscConcave-Custom-Footprint-YuXsnK.svg";